module.exports = __webpack_public_path__ + "img/new2.078c050f.jpg";